<template>
  <div style="height: 100%">
    <grid ref="grid" :config="gridConfig" class="no-grid-border">
      <template v-slot:grid-title>
        <h3 class="blue-text">{{L10n('replacement-parts')}}</h3>
      </template>
    </grid>
    <modal-new
      :config="{ id: gridConfig.id }"
      :rfqid="data.rfqid"
      :partID="data.partID"
    ></modal-new>
  </div>
</template>

<script>
import gridConfig from './GridConfig.json'
import { waitValue } from '@/utils/promises'

export default {
  name: 'RepairExchangeReplacement',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'RFQRepairTd' */ './ModalNew')
  },
  props: {
    data: { type: Object }
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  watch: {
    filterWatchValue: {
      immediate: true,
      handler () {
        this.getGrid()
          .then((grid) => {
            let { partID, rfqid } = this.data
            if (!partID || !rfqid) {
              grid.resetData()
            } else {
              grid.setFilters(`partID == ${partID} && rfqid == "${rfqid}"`)
              grid.loadData()
            }
          })
      }
    }
  },
  computed: {
    filterWatchValue () {
      let { partID, rfqid } = this.data
      return `${partID}-${rfqid}`
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs['grid'])
    }
  }
}
</script>
